
import { Box, makeStyles, MenuItem, Select } from '@material-ui/core'

import _ from 'lodash'
import React from 'react'
import ErrorBox from '../ErrorBox/ErrorBox'
import { Typography } from 'procyon-ui'
const defaultLabelExtractor = (option) => option
const defaultValueExtractor = (option) => option

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center'
  },

  select: {
    height: '2.5rem'
  }
}
))
const ThemeDropDown = ({ disabledHelp, defaultValue, hidelabel = false, labelMarginBottom = 0.5, mb = 0, height = 2.3, options = [], touched, errored, label, labelExtractor = defaultLabelExtractor, valueExtractor = defaultValueExtractor, ...rest }) => {
  const classes = useStyles({ height: height })
  const fieldId = _.uniqueId('field-')
  return (
    <>
      {!hidelabel &&
        <Typography variant='body-regular'>
          {label}
          {rest.disabled &&
            <Typography variant='body-small'>{` | ${disabledHelp} `}</Typography>}
        </Typography>}
      <Box mt={labelMarginBottom} mb={mb}>
        <Select
          labelId={fieldId}
          variant='outlined'
          fullWidth
          defaultValue={defaultValue}
          {...rest}
          className={classes.select}
        >
          {options.map((option) => (
            <MenuItem key={valueExtractor(option)} value={valueExtractor(option)}>
              {labelExtractor(option)}
            </MenuItem>
          ))}
        </Select>

        <ErrorBox
          error={errored}
          touched={touched}
        />
      </Box>
    </>
  )
}

export default ThemeDropDown

ThemeDropDown.propTypes = {
  // touched: PropTypes.bool
}

ThemeDropDown.defaultProps = {
  showLabel: false,
  touched: false
}
